import React, {useRef} from 'react';
import * as bibSearchStyles from '../../../styles/custom/bib-search.module.scss';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import {getI18n} from 'react-i18next';
import AppButton from '../AppButton';
import IconContainer from '../IconContainer';
import { followLink } from '../../../utils/utils';

const BibSearchEngine = ({elem}) => {
  const config = elem.config;

  const lang = getI18n().language;
  const formRef = useRef();
  const color = config?.style?.color?.toLowerCase() || 'white';
  const updatePrimoQuery = () => {
    if(!formRef.current) return;
    const tq = formRef.current.primoQueryTemp.value;
    formRef.current.primoQuery.value = `any,contains, ${tq}`;
  };

  return (
    <div className={clsx(bibSearchStyles.root, bibSearchStyles[color])}>
      <h2 className={bibSearchStyles.title}>{config?.style?.title}</h2>
      <p className={bibSearchStyles.subtitle}>{config?.style?.subTitle}</p>
      <form
        action={config.action_name}
        className={bibSearchStyles.form}
        encType="application/x-www-form-urlencoded; charset=utf-8"
        method="GET"
        ref={formRef}
        target={(config.newTab?.search ? '_blank' : '_self')}
      >
        <div
          className={bibSearchStyles.containerSearch}
        >
          {Object.entries(config.params || {}).map(([key, value], i) => {
            return (
              <input key={`${key}Key-${i}`}
                name={key}
                readOnly
                type="hidden"
                value={value}
              />
            );
          })}
          <input key ="languageKey"
            name="lang"
            readOnly
            type="hidden"
            value={lang}
          />
          <input id="primoQuery"
            key="primoQueryKey"
            name="query"
            type="hidden"
          />
          <input aria-label="Search"
            className={bibSearchStyles.input}
            defaultValue=""
            id="primoQueryTemp"
            key="primoQueryTempKey"
            label="searchtext"
            onChange={updatePrimoQuery}
            placeholder={config?.style?.placeholder}
            size="1"
            type="text"
          />
          <AppButton
            className={bibSearchStyles.button}
            color={(color === 'black') ? 'secondary' : 'primary'}
            label={config?.style?.searchButton}
            leftIcon={
              <IconContainer
                color="WHITE"
                icon="SEARCH"
                noHover
                size={20}
              />
            }
            padding={5}
            paddingWidth={10}
            variant="impact"
          >
            {config?.style?.searchButton}
          </AppButton>
        </div>
        <AppButton
          className={bibSearchStyles.secondButton}
          color={(color === 'black') ? 'primary' : 'secondary'}
          label={config?.style?.searchButton}
          onClick={(event) => {
            event.preventDefault();
            followLink(config?.style?.secondButtonUrl, config.newTab?.account ? '_blank' : '_self');
          }}
          padding={5}
          paddingWidth={10}
          variant="impact"
        >
          {config?.style?.secondButton}
        </AppButton>
      </form>
    </div>
  );
};

BibSearchEngine.propTypes = {
  elem: PropTypes.shape({
    config :PropTypes.object.isRequired,
    newTab : PropTypes.object
  })
};

export default BibSearchEngine;